import React, { useState } from "react"
import { Alert, Button } from "antd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faXmark } from "@fortawesome/free-solid-svg-icons"
import { useDashboardStore } from "features/Dashboard/runtime/dashboardStore"

/**
 * Over the canvas while the dashboard's preparation has failed: what failed
 * and, in Build mode, a way to the Data panel to fix it. Dismissing hides
 * it until the next preparation (the tiles still say what is wrong).
 */
const PrepErrorAlert: React.FC = () => {
  const prepError = useDashboardStore((s) =>
    s.session.status === "prep-error" ? (s.session.prepError ?? "") : null
  )
  const generation = useDashboardStore((s) => s.session.generation)
  const build = useDashboardStore((s) => s.mode === "build")
  const openDataPanel = useDashboardStore((s) => s.setDataPanelOpen)
  /** The session generation whose alert was dismissed. */
  const [dismissed, setDismissed] = useState<number | null>(null)
  if (prepError === null || dismissed === generation) return null
  return (
    <Alert
      className="dq-prep-alert"
      type="error"
      showIcon
      closable={{
        closeIcon: <FontAwesomeIcon icon={faXmark} />,
        "aria-label": "Dismiss",
      }}
      onClose={() => setDismissed(generation)}
      message={`Preparation failed: ${prepError}`}
      action={
        build ? (
          <Button size="small" onClick={() => openDataPanel(true)}>
            Open Data panel
          </Button>
        ) : undefined
      }
    />
  )
}

export default PrepErrorAlert
